module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x160-e5b4c580c1def370d5085a05bd9daf79.webp";